<template>
    <div class="fast-search">
        <button class="fast-search__button" @click="showSearch">
            <z-icon
                :color="buildColor"
                name="search"
                width="28"
                height="28"
            />
        </button>
        <transition name="fade">
            <div class="fast-search__content" v-if="show">
                <div class="fast-search__content-input">
                    <z-input
                        name="q"
                        theme="search"
                        @keyup.enter.native="goToFullSearch"
                        v-model="params.q"
                    ></z-input>
                </div>
                <button class="fast-search__content-icon" @click="goToFullSearch">
                    <z-icon
                        width="32"
                        height="32"
                        name="magnifying_glass">
                    </z-icon>
                </button>

                <button class="fast-search__content-close" @click="showSearch">
                    <z-icon
                        width="26"
                        height="26"
                        name="close"
                    >
                    </z-icon>
                </button>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'fast-search',
    data () {
        return {
            show: false,
            lang: this.$root.lang,
            params: {
                q: '',
                page: 1
            }
        }
    },
    methods: {
        goToFullSearch () {
            window.location = `/${this.$root.lang}/search/?q=${this.params.q}`
        },
        showSearch () {
            this.show = !this.show
        }
    },
    computed: {
        allResultsLink () {
            return `/${this.lang}/search/?q=${this.params.q}`
        },
        buildColor () {
            let isInvert = document.body.classList.contains('invert')
            return isInvert ? 'white' : 'black'
        }
    }
}
</script>

<style lang="scss" src="./index.scss"></style>
